import { locationsApi } from '../client/environment';
import { GeoLocation, CurrentAddress } from '../client/appTypings';

import { authFetch as createAuthFetch } from '../client/domain/AuthFetch';
import { logger } from '../common/logger';
import { getClientYleApiCredentials } from '../client/utils/authKeys';

const getGeoLocationValue = (
  country_code: string,
  is_portability_region: boolean
) => {
  if (country_code === 'FI') return GeoLocation.Finland;
  if (is_portability_region) return GeoLocation.PortabilityRegion;
  return GeoLocation.World;
};

export async function fetchGeoLocation(): Promise<CurrentAddress> {
  const url = `${locationsApi}/v4/address/current`;
  const authenticationKeys = getClientYleApiCredentials();

  try {
    const authFetch = createAuthFetch({}, authenticationKeys);
    const response = await authFetch(url);

    const { country_code, is_portability_region, city, city_region, asnum } =
      await response.json();

    const currentAddress = {
      city,
      city_region,
      asnum,
      geoLocation: getGeoLocationValue(country_code, is_portability_region),
      countryCode: country_code,
    };
    return currentAddress;
  } catch (ex) {
    const message = ex instanceof Error ? ex.message : '' + ex;

    logger.error(
      ex as object,
      `Caught exception while querying locations-api: ${message}`
    );
  }
  return {
    geoLocation: GeoLocation.World,
  };
}
